const MessageCenterTypes = {
  SET_OPEN: 'MESSAGE_CENTER.SET_OPEN',
  SET_ACTIVE_FOLDER_ID: 'MESSAGE_CENTER.SET_ACTIVE_FOLDER_ID',
  SET_ACTIVE_MESSAGE_ID: 'MESSAGE_CENTER.SET_ACTIVE_MESSAGE_ID',

  GET_FOLDERS_PROGRESS: 'MESSAGE_CENTER.GET_FOLDERS_PROGRESS',
  GET_FOLDERS_SUCCESS: 'MESSAGE_CENTER.GET_FOLDERS_SUCCESS',
  GET_FOLDERS_ERROR: 'MESSAGE_CENTER.GET_FOLDERS_ERROR',

  GET_MESSAGE_LIST_PROGRESS: 'MESSAGE_CENTER.GET_MESSAGE_LIST_PROGRESS',
  GET_MESSAGE_LIST_SUCCESS: 'MESSAGE_CENTER.GET_MESSAGE_LIST_SUCCESS',
  GET_MESSAGE_LIST_ERROR: 'MESSAGE_CENTER.GET_MESSAGE_LIST_ERROR',

  GET_MESSAGE_DETAILS_PROGRESS: 'MESSAGE_CENTER.GET_MESSAGE_DETAILS_PROGRESS',
  GET_MESSAGE_DETAILS_SUCCESS: 'MESSAGE_CENTER.GET_MESSAGE_DETAILS_SUCCESS',
  GET_MESSAGE_DETAILS_ERROR: 'MESSAGE_CENTER.GET_MESSAGE_DETAILS_ERROR',

  DELETE_MESSAGE_PROGRESS: 'MESSAGE_CENTER.DELETE_MESSAGE_PROGRESS',
  DELETE_MESSAGE_SUCCESS: 'MESSAGE_CENTER.DELETE_MESSAGE_SUCCESS',
  DELETE_MESSAGE_ERROR: 'MESSAGE_CENTER.DELETE_MESSAGE_ERROR',

  MARK_AS_READ_MESSAGE_PROGRESS: 'MESSAGE_CENTER.MARK_AS_READ_MESSAGE_PROGRESS',
  MARK_AS_READ_MESSAGE_SUCCESS: 'MESSAGE_CENTER.MARK_AS_READ_MESSAGE_SUCCESS',
  MARK_AS_READ_MESSAGE_ERROR: 'MESSAGE_CENTER.MARK_AS_READ_MESSAGE_ERROR',

  GET_COMPOSE_EMAILS_ID_SEARCH_PROGRESS: 'MESSAGE_CENTER.GET_COMPOSE_EMAILS_ID_SEARCH_PROGRESS',
  GET_COMPOSE_EMAILS_ID_SEARCH_SUCCESS: 'MESSAGE_CENTER.GET_COMPOSE_EMAILS_ID_SEARCH_SUCCESS',
  GET_COMPOSE_EMAILS_ID_SEARCH_ERROR: 'MESSAGE_CENTER.GET_COMPOSE_EMAILS_ID_SEARCH_ERROR',

  SEND_MESSAGE_PROGRESS: 'MESSAGE_CENTER.SEND_MESSAGE_PROGRESS',
  SEND_MESSAGE_SUCCESS: 'MESSAGE_CENTER.SEND_MESSAGE_SUCCESS',
  SEND_MESSAGE_ERROR: 'MESSAGE_CENTER.SEND_MESSAGE_ERROR',
};

export default MessageCenterTypes;
